import { useTranslation } from 'react-i18next';

function RejectConfirmModal() {
  const { t } = useTranslation();

  return <div>{t('text:The_registration_request_has_been_rejected')}</div>;
}

export default RejectConfirmModal;
